import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { withStyles, TextField, Typography } from '@material-ui/core';

import {
    getTextfieldDateString, getNumberOfWeeks, msInOneWeek, today, pad2, getLocalDate,
} from '../../../youwell-common/dateUtils';
import { getSkillWeeks, skillStartHour } from './utils';

const styles = theme => ({
    root: {
        padding: theme.spacing(1),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    inputWeeks: {
        marginRight: theme.spacing(1),
        width: 100,
    },
    inputDate: {
        marginRight: theme.spacing(1),
    },
    inputField: {
        minWidth: 100, // fix for ios. Must have min-width to be visible when no value is set
    },
    weekNumber: {
        width: 65,
    },
});


class TimePeriod extends React.Component {
    onNumberOfWeeksChange = (event) => {
        const start = this.props.skill.startTime ? getLocalDate(this.props.skill.startTime) : today(skillStartHour);
        const weeks = Number(event.target.value);

        this.updateData(start, Math.min(weeks, 12));
    }

    onStartTimeChange = (event) => {
        const weeks = getNumberOfWeeks(this.props.skill.startTime, this.props.skill.endTime) || 3;
        const start = event.target.value ? getLocalDate(`${event.target.value}T${pad2(skillStartHour)}:00`) : today(skillStartHour);

        this.updateData(start, weeks);
    }

    updateData = (start, weeks) => {
        const end = new Date(start.getTime() + (msInOneWeek * Number(weeks)));

        this.props.onChange({
            startTime: start.toISOString(),
            endTime: end.toISOString(),
        });
    }

    render() {
        const {
            classes, translate, skill, disabled,
        } = this.props;

        if (!skill) {
            return null;
        }

        const { fromWeek, toWeek, numberOfWeeks } = getSkillWeeks(skill);

        return (
            <div className={classes.root}>
                <TextField
                    label={translate('studentPlan.startDate')}
                    type="date"
                    value={skill.startTime ? getTextfieldDateString(skill.startTime) : ''}
                    onChange={this.onStartTimeChange}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{ classes: { input: classes.inputField } }}
                    className={classes.inputDate}
                    disabled={disabled}
                />
                {skill.startTime && (
                    <TextField
                        label={translate('studentPlan.numberOfWeeks')}
                        type="number"
                        value={numberOfWeeks}
                        onChange={this.onNumberOfWeeksChange}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{ inputProps: { min: 1, max: 12 } }}
                        className={classes.inputWeeks}
                        disabled={disabled}
                    />
                )}
                {numberOfWeeks > 0 && (
                    <div className={classes.weekNumber}>
                        <Typography variant="caption">
                            {translate('studentPlan.weekNumber')}
                        </Typography>
                        <Typography variant="h6">
                            {numberOfWeeks > 1 ? `${fromWeek} - ${toWeek}` : fromWeek}
                        </Typography>
                    </div>
                )}
            </div>
        );
    }
}

TimePeriod.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    skill: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
};

TimePeriod.defaultProps = {
    disabled: false,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default connect(mapStateToProps)(withStyles(styles)(TimePeriod));
